var map = {
	"./rock-album-1.png": 73970,
	"./rock-album-2.png": 39113,
	"./rock-album-3.png": 84288,
	"./rock-album-4.png": 42943,
	"./rock-album-5.png": 64854,
	"./rock-album-6.png": 55533,
	"./rock-album-7.png": 29380,
	"./rock-album-8.png": 73251,
	"./rock-album-9.png": 51674
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19947;